import { AxiosError } from "axios";
import { axiosFinancial, createAuthHeaders } from "./financialApi";

export const downloadKamReport = async (
  startDate: Date | string | null,
  endDate: Date | string | null,
  vision?: string,
  filters?: {
    corbanId?: number;
    promotoraId?: number;
    gerenteName?: string;
    vendedorName?: string;
  }
): Promise<void> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    vision,
    ...(filters?.corbanId ? { corbanId: filters.corbanId } : {}),
    ...(filters?.promotoraId ? { promotoraId: filters.promotoraId } : {}),
    ...(filters?.gerenteName ? { gerenteName: filters.gerenteName } : {}),
    ...(filters?.vendedorName ? { vendedorName: filters.vendedorName } : {}),
  };

  try {
    const response = await axiosFinancial.get("/api/kam", {
      params,
      responseType: "arraybuffer",
      headers: createAuthHeaders(),
    });

    const file = new Blob([response.data], {
      type: "application/zip",
    });

    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = "relatorio_kam.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    const decoder = new TextDecoder("utf-8");

    if (error instanceof AxiosError && error.response) {
      const errorResponse = decoder.decode(error.response.data);
      const errorObject = JSON.parse(errorResponse);
      throw new Error(errorObject.error.replace(/^Error:\s/, ""));
    }
    throw new Error(error);
  }
};

export const getKamPaginated = async (
  startDate: string,
  endDate: string,
  page: number,
  pageSize: number,
  vision?: string,
  filters?: {
    corbanId?: number;
    corbanName?: string;
    promotoraId?: number;
    gerenteName?: string;
    vendedorName?: string;
  }
): Promise<any> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    page,
    pageSize,
    vision,
    ...(filters?.corbanId ? { corbanId: filters.corbanId } : {}),
    ...(filters?.corbanName ? { corbanName: filters.corbanName } : {}),
    ...(filters?.promotoraId ? { promotoraId: filters.promotoraId } : {}),
    ...(filters?.gerenteName ? { gerenteName: filters.gerenteName } : {}),
    ...(filters?.vendedorName ? { vendedorName: filters.vendedorName } : {}),
  };

  try {
    const response = await axiosFinancial.get("/api/kam-paginated", {
      params,
      headers: createAuthHeaders(),
    });
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.error || error.message || error);
  }
};
